export const formatWalletBalance = (value: number) =>
  `₹${(Number(value) || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  })}`;

export const formatWalletDate = (value: Date | string) =>
  value ? new Date(value).toLocaleString() : "—";
